require("./bootstrap");

import Alpine from "alpinejs";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import collapse from "@alpinejs/collapse";
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
window.addEventListener("DOMContentLoaded", function () {
   var calendarEl = document.getElementById("calendar");
   if (calendarEl != null) {
      var calendar = new Calendar(calendarEl, {
         plugins: [
            dayGridPlugin,
            timeGridPlugin,
            listPlugin,
            interactionPlugin,
         ],
         editable: true,
         selectable: true,
         timeZone: "America/Chicago",
         select: function (selInfo) {
            createEvent(selInfo);
         },
         initialView: "dayGridMonth",
         headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,listWeek",
         },
         dayMaxEvents: true,
         views: {
            dayGrid: { dayMaxEventRows: 2 },
         },
         moreLinkClick: "popover",
         events: "/fullcalender",
         navLinks: true,
         navLinkDayClick: true,
         themeSystem: true,
         eventDisplay: "block",
         eventBackgroundColor: "#717171",
         eventBorderColor: "#717171",
         eventClick: function (info) {
            deleteEvent(info);
         },
         longPressDelay: 1000,
      });
      calendar.render();
   }
});

function deleteEvent(info) {
   Livewire.emit("deleteTransportEvent", info.event.id);
}
function createEvent(info) {
   var date = new Date(info.start);
   let start = info.start;
   let end = info.end;
   let title = prompt("Enter a title");
   let thisDay = new Date(info.start);
   title && Livewire.emit("createTransportEvent", { title, start, end });
}
